"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDayPicker = _interopRequireDefault(require("react-day-picker"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _styles = require("@qc-modules/styles");

var _components = require("./components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var StyledDayPicker = (0, _styledComponents["default"])(_reactDayPicker["default"]).withConfig({
  displayName: "day-picker__StyledDayPicker",
  componentId: "sc-1ay2xuv-0"
})(["z-index:10;", ";margin-top:8px;position:absolute;border-radius:8px;border:1px solid ", ";", ";box-shadow:0 4px 10px 1px ", ";.DayPicker-wrapper{position:relative;user-select:none;flex-direction:row;}.DayPicker-Months{display:flex;flex-wrap:wrap;justify-content:center;padding:0 16px 8px 16px;}.DayPicker-Month{display:table;border-collapse:collapse;border-spacing:0;user-select:none;width:100%;}.DayPicker-NavButton--interactionDisabled{display:none;}.DayPicker-Weekdays{display:table-header-group;}.DayPicker-WeekdaysRow{display:table-row;}.DayPicker-Weekday{display:table-cell;}.DayPicker-Body{display:table-row-group;}.DayPicker-Week{display:table-row;}.DayPicker-Day{display:table-cell;cursor:pointer;vertical-align:middle;outline:none;padding:5px;width:38px;p{", ";border-radius:50%;display:flex;align-items:center;justify-content:center;height:100%;width:100%;}&:hover{p{background-color:", ";}}&--selected{p{color:", ";background-color:", ";}&:hover{p{background-color:", ";}}}&--today{p{border-radius:50%;background-color:", ";}}&--outside{p{color:", ";}}}.DayPicker-Day--disabled{}"], (0, _styledSystem.compose)(_styledSystem.color, _styledSystem.opacity, _styledSystem.width), function (props) {
  return (0, _styles.colors)("border", props);
}, (0, _styles.transitionEase)("0.3s", ["border", "box-shadow"]), function (props) {
  return (0, _styles.themeTransparentize)(0.9, "black", props);
}, (0, _styles.defaultTransition)(["background", "color"]), function (props) {
  return (0, _styles.themeTransparentize)(0.6, "background-light", props);
}, function (props) {
  return (0, _styles.colors)("text-light", props);
}, function (props) {
  return (0, _styles.colors)("background-selected", props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.2, "background-selected", props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.8, "background-light", props);
}, function (props) {
  return (0, _styles.colors)("text-helper", props);
});

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledDayPicker, _extends({
    captionElement: /*#__PURE__*/_react["default"].createElement(_components.Caption, null),
    navbarElement: /*#__PURE__*/_react["default"].createElement(_components.Navbar, null),
    renderDay: _components.RenderDay,
    weekdayElement: /*#__PURE__*/_react["default"].createElement(_components.Weekday, null)
  }, props));
};

exports["default"] = _default;
StyledDayPicker.displayName = "Modules.StyledDayPicker";